<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="details"
      ref="list"
      unit="工单进度情况表"
      :page="page"
      :show-query="true"
      :get-data-func="api.getWdpProgress"
      v-if="trendShow"      
      :summary-method="getSummary"
      :resetDataFunc="resetDataFunc"
      urlHash="production/ticketmanagement/progress"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
  </div>
</template>
<script>
import listMixin from '@/mixins/trend/list'
import list from '@/components/common/trendsTable/list'

export default {
  mixins: [listMixin],
  components: { list },
  provide() {
    return {
      IsDefaultMonth: false
    }
  },
  data() {
    return {
      api: require('@/api/production/workDoc').default,
      trendShow: true
    }
  },
  methods: {
    resetDataFunc(data){
      data.forEach(item => {
        if(item.Stage==0){
          item.ProductNo =item.MouldNo
          item.ProductName=item.MouldName
        }
      })
      console.log('======data=========', data)
       return data
    },
    getSummary(param) {
      const { columns, data } = param;
      let labels = ["生产数量","累计入库数量","未入库数量"];

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => {
          if (labels.includes(column.label)) {
            return Number(item[column.property]);
          }
        });

        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index];
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
  },
}
</script>
